import React from 'react';

/**
 * Suspense fallback for lazily-loaded routes.
 *
 * Reserves the viewport height the incoming page will occupy so swapping the
 * fallback for real content doesn't shift the header/footer (avoids a CLS hit),
 * and stays silent for the first moment so fast chunk loads never flash a spinner.
 */
export const RouteFallback = () => (
  <div
    className="min-h-[60vh] flex items-center justify-center"
    role="status"
    aria-live="polite"
    aria-label="Loading page"
  >
    <div className="oli-route-spinner" />
    <span className="sr-only">Loading…</span>
  </div>
);

export default RouteFallback;
